<template>
    <paper class="performancePureTransportationConfig">
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :searchTotalTitle="config.searchTotalTitle"
            :loading="loading"
            :currentPage="query.pageNo"
            @del-btn="handleDelBtn"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            searchId="driverManageQuery"
            pageID="driverManage"
        >

        <div slot="table-module-btn">
            <el-tooltip
                class="item"
                effect="dark"
                content="新增"
                placement="bottom"
            >
                <el-button
                    size="mini"
                    icon="el-icon-plus"
                    @click="handleAddData"
                ></el-button>
            </el-tooltip>
        </div>
        </m-pane>

        <!-- 新增弹窗 -->
        <driver-manage-dialog
            ref="performanceCreationDialog"
            :title="title"
            :supplierCode="query.supplierCode"
            :dialogVisible.sync="dialogVisible"
            v-if="dialogVisible"
            @handleClose="handleClose"
            @handleSuccess="handleSuccess"
        ></driver-manage-dialog>
    </paper>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import paper from '@/components/core/paper/Paper';
import mPane from '@/components/otpPanel';
import driverManageDialog from './component/driverManageDialog.vue';
import config from './config.js';
import * as api from '../../../api/driverManage.js';
export default {
    name: 'driverManage',
    components: {
        paper,
        mPane,
        driverManageDialog
    },
    data () {
        return {
            config,
            pageTotal: 0,
            loading: false,
            dialogVisible: false,
            totalData: [],
            title: '',
            query: {
                pageNo: 1, pageSize: 10, supplierCode: '',
                param: {
                    driverName: '',
                    driverPhone: ''
                }
            },
            rowData: {}
        };
    },
    computed: {
        ...mapGetters(['user']),
        ...mapState({
            supplier: state => state.supplier
        })
    },
    mounted () {
        this.query.supplierCode = this.supplier.supplierCode;
    },
    methods: {
        // 获取列表
        getList () {
            this.loading = true;
            api.driverGetList(this.query).then(res => {
                if (res && +res.code === 0) {
                    this.pageTotal = res.data.totalCount || 0;
                    this.totalData = res.data.list || [];
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        /**
         * @description 新增
         */
        handleAddData () {
            this.title = '新增司机';
            this.rowData = {};
            this.dialogVisible = true;
        },
        handleClose () {
            this.dialogVisible = false;
        },
        handleSuccess () {
            this.handleClose();
            this.getList();
        },
        /**
         * @description 删除
         */
        handleDelBtn (data) {
            this.$confirm('确定删除该条数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                api.deleteDriver(data.id).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('删除成功');
                        this.getList();
                    }
                });
            });
        },

        /**
         * @description 组装查询参数
         * @param {Object} data 查询参数
         */
        getSearchData (data) {
            const _searchData = {
                ...this.query,
                pageNo: 1,
                param: {
                    ...data
                }
            };
            return _searchData;
        },
        // 查询
        searchChange (data) {
            this.query = this.getSearchData(data);
            this.getList();
        },
        // 表格数据选中
        selectChange (data) {
            this.selected = data;
        },
        // 切换当前页数
        pageChange (pageNo) {
            this.query.pageNo = pageNo;
            this.getList();
        },
        // 切换当前分页显示条数
        sizeChange (pageSize) {
            this.query.pageNo = 1;
            this.query.pageSize = pageSize;
            this.getList();
        }
    }
};
</script>
